// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const customizeHatvViewAPI = createApi({
  reducerPath: "customizeHatvViewAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["hatvView"],
  endpoints: (builder) => ({
    getHatvViewsList: builder.query<any, getViewArgsType>({
      query: ({ type }) => ({
        url: `/am/view/type/${type}`,
        method: "GET",
      }),
      providesTags: ["hatvView"],
    }),
    createHatvViews: builder.mutation<any, createViewArgsType>({
      query: ({ payload }) => ({
        url: `/am/view/create/type/qapproval`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["hatvView"],
    }),
    updateHatvViews: builder.mutation<any, updateViewArgsType>({
      query: ({ payload }) => ({
        url: `/am/view/update/type/qapproval`,
        method: "PUT",
        data: payload,
      }),
      invalidatesTags: ["hatvView"],
    }),

    getFilteredAccountList: builder.mutation<any, CreateHatvViewArgs>({
      query: ({ payload, month }) => ({
        url: `/am/myqmonthapproval/view/month/${month}`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["hatvView"],
    }),

    deleteHatvView: builder.mutation<any, viewArgTypes>({
      query: ({viewId}) => ({
        url: `/am/view/${viewId}`,
        method: "delete",
        }),
        invalidatesTags: ["hatvView"],
  
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetHatvViewsListQuery,
  useLazyGetHatvViewsListQuery,
  useCreateHatvViewsMutation,
  useUpdateHatvViewsMutation,
  useGetFilteredAccountListMutation,
  useDeleteHatvViewMutation,
} = customizeHatvViewAPI;
